import React, { useContext } from "react";
import { ReactComponent as EditIcon } from "../../../../../assets/img/svg/Edit2.svg";
import APopover from "../../common/a-popover/index";
import EditBranchesCommonComponent from "../../common/branchesCommonComponent/EditBranchesCommonComponent";
import ViewBranchesCommonComponent from "../../common/branchesCommonComponent/ViewBranchesCommonComponent";
import { endpoint, pages } from "../../common/constant";
import { PermissionContext, RolePermissions } from "appContext";
import {
  checkPermission,
  fetchAllPromisedData,
} from "../../common/utils/methods/commonMethods/utilityMethod";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper";

const editIconStyles = {
  height: "15px",
  width: "15px",
  cursor: "pointer",
  marginLeft: "5px",
};

const BranchesCellComponent = ({ params, planData, updateHandler }) => {
  const userPermissions = RolePermissions(
    useContext(PermissionContext),
    pages["searchAcademicPlan"]["id"]
  );

  const [isLoading, setIsLoading] = React.useState(false);
  const [responseData, setResponseData] = React.useState({
    regions: [],
    businessAreas: [],
  });

  const fetchData = async () => {
    setIsLoading(true);
    const response = await fetchAllPromisedData(
      `${endpoint.viewAcademicPlan.getPlanById}/${planData.id}?requireDispValue=true`,
      true
    );

    if (response?.data) {
      const { businessAreas, regions } = response?.data;
      setResponseData({ businessAreas, regions });
    } else {
      setResponseData({
        regions: [],
        businessAreas: [],
      });
    }
    setIsLoading(false);
  };

  const { businessAreas, regions } = responseData;

  return (
    <div>
      <span>
        <span style={{ color: "#00B0F5" }}>
          <APopover
            buttonComponent={(onClick, styles) => (
              <span
                onClick={(e) => {
                  onClick(e);
                  fetchData();
                }}
                style={{ cursor: "pointer" }}
              >
                View
              </span>
            )}
            menuComponent={(closeForm) =>
              isLoading ? (
                <p className="text-sm m-3">Loading...</p>
              ) : (
                <ViewBranchesCommonComponent
                  regions={regions}
                  businessAreas={businessAreas}
                  closeForm={closeForm}
                />
              )
            }
          />
        </span>

        {checkPermission(userPermissions, "U") && (
          <APopover
            buttonComponent={(onClick, styles) => (
              <IconButtonWrapper
                onClick={(e) => {
                  onClick(e);
                  fetchData();
                }}
              >
                <EditIcon style={editIconStyles} />
              </IconButtonWrapper>
            )}
            menuComponent={(closeForm) =>
              isLoading ? (
                <p className="text-sm m-3">Loading...</p>
              ) : (
                <EditBranchesCommonComponent
                  closeForm={closeForm}
                  regions={regions?.map((item) => ({
                    label: item?.dispValue,
                    value: item?.id,
                  }))}
                  businessAreas={businessAreas?.map((item) => ({
                    label: item?.dispValue,
                    value: item?.id,
                  }))}
                  updateHandler={(updatedForm) =>
                    updateHandler(planData, updatedForm)
                  }
                />
              )
            }
          />
        )}
      </span>
    </div>
  );
};

export default BranchesCellComponent;
